import { AssertionException } from './utils/log';
import { IPanorama } from '@ael/core-api';

let pano: IPanorama | null = null;

export function setGlobalPanorama(panorama: IPanorama) {
  pano = panorama;
}

export const getMainProjectPanorama = (): IPanorama => {
  if (pano) {
    return pano;
  }

  throw AssertionException('Panorama has to be ready before accessing it directly');
};

export const getMainProjectPanoramaMaybe = (): IPanorama | undefined => {
  if (pano) {
    return pano;
  }
  return undefined;
};
